import { useContext } from 'react';
import { useGetCompany } from '../../../../api/company';
import { Field, Panel } from '../../../../layouts';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function StoreInformationPanel() {

	const { order } = useContext(WorkOrderContext);
	const store = useGetCompany(order.details.dealerCompanyID);

	return (
		<>
			<Panel
				header={'Store Information'}
			>
				<Field label={'Parent Company'} >{store.data?.parentCompanyName}</Field>
				<Field label={'Number'} >{store.data?.companyCode + ' - ' + store.data?.companyName}</Field>
				<Field label={'Address'} >{store.data?.PA_Address1}</Field>
				<Field label={''} visible={!!store.data?.PA_Address2}>{store.data?.PA_Address2}</Field>
				<Field label={''} >{store.data?.PA_City + ', ' + store.data?.PA_State + ' ' + store.data?.PA_Zip}</Field>
				<Field label={'Phone'} >{store.data?.phone}</Field>
				<Field label={'Fax'} >{store.data?.fax}</Field>
			</Panel>
		</>
	);
}
